<app-navbar></app-navbar>
<div class="app-container">
  <router-outlet></router-outlet>
  <app-freshdesk></app-freshdesk>
</div>

<ngx-loading [show]="loading()" [config]="loadingSpinnerConfig"></ngx-loading>
